/** @jsx isolateComponent */

import { Button, Link, Spacer, Text } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useSendFullStoryEvent, useTrackEvent } from '@zapier/toolbox-tracking';

import { Plan } from '@zapier/upsells/src/types';

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: 600,
    textAlign: 'center' as 'center',
  },
};

type Props = {
  autoUpgradeToPlan: Plan;
  onClose: () => void;
};

export const AutoUpgradeCelebrateView = ({
  autoUpgradeToPlan,
  onClose,
}: Props) => {
  useSendFullStoryEvent('Viewed Auto Upgrade Modal - Celebrate View');
  useTrackEvent('auto_upgrade_modal_celebrate_view');

  return (
    <div css={styles.container}>
      <Text tag="h1" type="sectionHeader3">
        All set! The automatic task upgrade feature is on.
      </Text>

      <Spacer height={20} />

      <Text color="gray60" tag="p" type="paragraph3">
        We'll automatically move you to the {autoUpgradeToPlan.type} plan with{' '}
        {Number(autoUpgradeToPlan.tasks).toLocaleString()} tasks if you run out
        of tasks. Change this setting any time from your{' '}
        <Link href="/app/settings/billing">Billing and Usage</Link> settings.
      </Text>

      <Spacer height={30} />

      <Button hasShadow={true} onClick={onClose}>
        Close
      </Button>
    </div>
  );
};
